import Decimal from "decimal.js";
import { format } from "date-fns";
import { ITEM_UNIT_ABBREVIATION, ItemUnit } from "@forgepoint/shared";

export function formatDateInput(
  date: Date | string | null | undefined,
): string {
  if (!date) {
    return "";
  }
  return format(new Date(date), "yyyy-MM-dd");
}

export function parseDateInput(value: string): Date {
  return new Date(`${value}T00:00:00`);
}

export function formatMoney(value: string | Decimal | number): string {
  const decimal = value instanceof Decimal ? value : new Decimal(value || 0);
  return decimal.toNumber().toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatQuantity(value: string): string {
  return new Decimal(value || 0).toNumber().toLocaleString("en-US", {
    maximumFractionDigits: 2,
  });
}

export function formatQuantityWithUnit(value: string, unit: ItemUnit): string {
  return `${formatQuantity(value)} ${ITEM_UNIT_ABBREVIATION[unit]}`;
}
